import timer from './modules/store'

export const modules = {
  timer
}



// WEBPACK FOOTER //
// ./src/store/Timer/index.js